import { render, staticRenderFns } from "./BenefitAnalysis.vue?vue&type=template&id=a3320d4c&scoped=true"
import script from "./BenefitAnalysis.vue?vue&type=script&lang=js"
export * from "./BenefitAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BenefitAnalysis.vue?vue&type=style&index=0&id=a3320d4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3320d4c",
  null
  
)

export default component.exports